import { render, staticRenderFns } from "./Careerbook.vue?vue&type=template&id=5dce73d6&"
import script from "./Careerbook.vue?vue&type=script&lang=js&"
export * from "./Careerbook.vue?vue&type=script&lang=js&"
import style0 from "./Careerbook.vue?vue&type=style&index=0&id=5dce73d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports